import { useContext, useEffect } from "react";
import UserContext from "../components/Common/UserContext";

const Presenter = () => {
  const { userRole, setUserRole } = useContext(UserContext);
  useEffect(() => {
    setUserRole("Presenter");
    sessionStorage.setItem("userRole", "Presenter");
  }, []);

  return (
    <>
      <h1 style={{ textAlign: "center", margin: "20px" }}>
        Welcome, Please Toggle to See different Users
      </h1>
    </>
  );
};

export default Presenter;
